export const ticketUpdateEmailPlaceholderTokens = [
  "actor_name",
  "recipient_name",
  "reply_to_address",
  "ticket_notes",
  "ticket_number",
  "ticket_status",
  "ticket_title",
  "workspace_name",
] as const;

export type TicketUpdateEmailPlaceholderToken = typeof ticketUpdateEmailPlaceholderTokens[number];

export const defaultTicketUpdateEmailTemplateSubject = "Update on {{ticket_number}}: {{ticket_title}}";

export const defaultTicketUpdateEmailTemplateHtml = `<!doctype html>
<html lang="en">
  <body style="margin:0;padding:0;background-color:#f4f7fb;">
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="width:100%;border-collapse:collapse;background-color:#f4f7fb;margin:0;padding:0;">
      <tr>
        <td align="center" style="padding:32px 16px;">
          <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="width:100%;max-width:640px;border-collapse:separate;background-color:#ffffff;border:1px solid #e5e7eb;">
            <tr>
              <td style="padding:28px 32px;background-color:#0f172a;">
                <p style="margin:0 0 12px 0;font-family:Arial,sans-serif;font-size:12px;line-height:16px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#d0d5dd;">{{workspace_name}}</p>
                <p style="margin:0;font-family:Arial,sans-serif;font-size:28px;line-height:34px;font-weight:700;color:#ffffff;">{{ticket_number}} · {{ticket_title}}</p>
              </td>
            </tr>
            <tr>
              <td style="padding:32px;">
                <p style="margin:0 0 16px 0;font-family:Arial,sans-serif;font-size:16px;line-height:24px;color:#101828;">Hi {{recipient_name}},</p>
                <p style="margin:0 0 18px 0;font-family:Arial,sans-serif;font-size:15px;line-height:24px;color:#475467;">{{actor_name}} posted an update on your ticket. Reply to <strong>{{reply_to_address}}</strong> if you need to respond.</p>
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="width:100%;border-collapse:separate;border:1px solid #e5e7eb;background-color:#f8fafc;margin:0 0 24px 0;">
                  <tr>
                    <td style="padding:16px 18px;">
                      <p style="margin:0 0 6px 0;font-family:Arial,sans-serif;font-size:11px;line-height:16px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#667085;">Ticket status</p>
                      <p style="margin:0;font-family:Arial,sans-serif;font-size:16px;line-height:24px;font-weight:700;color:#101828;">{{ticket_status}}</p>
                    </td>
                  </tr>
                </table>
                {{ticket_notes}}
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>`;

export function normalizeOutboundTemplateHtml(value: string | null | undefined) {
  const normalized = typeof value === "string" ? value.trim() : "";
  return normalized || null;
}

export function normalizeOutboundTemplateSubject(value: string | null | undefined) {
  const normalized = typeof value === "string" ? value.trim() : "";
  return normalized || null;
}

export function renderEmailTemplate(template: string, placeholders: Record<string, string>) {
  let rendered = template;

  for (const [key, value] of Object.entries(placeholders)) {
    rendered = rendered.replaceAll(`{{${key}}}`, value);
  }

  return rendered;
}
